import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarDay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 2C7.55312 2 8 2.44687 8 3V4H12V3C12 2.44687 12.4469 2 13 2C13.5531 2 14 2.44687 14 3V4H15C16.1031 4 17 4.89687 17 6V15C17 16.1031 16.1031 17 15 17H5C3.89688 17 3 16.1031 3 15V6C3 4.89687 3.89688 4 5 4H6V3C6 2.44687 6.44688 2 7 2ZM7 10C6.44688 10 6 10.4469 6 11V13C6 13.5531 6.44688 14 7 14H9C9.55312 14 10 13.5531 10 13V11C10 10.4469 9.55312 10 9 10H7Z",
		fill: "#407BFF"
	})
});
export default SvgCalendarDay;
